import { render, staticRenderFns } from "./CourierSupplierServiceList.vue?vue&type=template&id=1fd9087e&scoped=true&"
import script from "./CourierSupplierServiceList.vue?vue&type=script&lang=js&"
export * from "./CourierSupplierServiceList.vue?vue&type=script&lang=js&"
import style0 from "./CourierSupplierServiceList.vue?vue&type=style&index=0&id=1fd9087e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9087e",
  null
  
)

export default component.exports